export default __webpack_public_path__ + "static/media/student-mob.157b6903.png";